/* global swal */
import './style.less';
import modalTemplate from 'modals/onboardProfile/template.html';
import modalController from 'modals/onboardProfile';

export default function($log, $uibModal) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  function activate() {
    $log.debug('User profile onboarind activated');

    $uibModal.open({
      template: modalTemplate,
      backdrop: 'static',
      size: 'md',
      keyboard: false,
      controller: modalController,
      controllerAs: 'onboardProfileCtrl'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/onboard/profile/index.js